var map = {
	"./agro.svg": "c4bd",
	"./airflow.svg": "08b8",
	"./alias.svg": "17d9",
	"./droplet.svg": "f906",
	"./droplet_blue.svg": "cdbc",
	"./droplet_gray.svg": "043c",
	"./droplet_red.svg": "9415",
	"./fecha.svg": "5ae0",
	"./flow.svg": "4a77",
	"./flow_blue.svg": "9070",
	"./flow_gray.svg": "1ef6",
	"./flow_red.svg": "3ffd",
	"./humedad.svg": "0455",
	"./humedad_blue.svg": "9cf1",
	"./humedad_gray.svg": "3a4c",
	"./humedad_red.svg": "1725",
	"./lluvia.svg": "f15e",
	"./lluvia_blue.svg": "2f8d",
	"./lluvia_gray.svg": "7094",
	"./lluvia_red.svg": "3db0",
	"./nivel_luz.svg": "b72a",
	"./nivel_luz_blue.svg": "f4d0",
	"./nivel_luz_gray.svg": "9c1e",
	"./nivel_luz_red.svg": "384c",
	"./pressure_blue.svg": "e477",
	"./pressure_gray.svg": "3f46",
	"./pressure_label.svg": "d9dd",
	"./pressure_red.svg": "8c77",
	"./statistics.svg": "7a7b",
	"./temperature.svg": "1811",
	"./temperature_blue.svg": "f1ac",
	"./temperature_gray.svg": "624a",
	"./temperature_red.svg": "6f62"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a0bd";